import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export type Dimensions = {
  x: number;
  y: number;
  h: number;
  w: number;
};

export interface Section {
  id: string;
  dimensions: Dimensions;
  component: string;
  settings: Record<string, any>;
}

export interface Data {
  title: string;
  subtitle: string;
  sections: Section[];
  _id: string;
}

export interface ConfigurableGridState {
  data: Data;
  error?: ErrorObject;
}

const initialState = {
  data: {}
} as ConfigurableGridState;

export default initialState;
